import { IOrderDelivered } from 'my-poppies-b2b-types';

import { timestampMockHelpers } from '@/utils/timestampMockHelpers';

export const dummyDataOrdersDelivered: IOrderDelivered[] = [
  {
    userRole: 'EVA',
    erpId: 'some-erpId-12955555',
    sender: 'SOME_SENDER',
    id: 'first-delivered-order',
    priority: 'HIGH',
    createdBy: 'SAM',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'SAM',
    updatedAt: timestampMockHelpers.now,
    customerId: 'customer-0',
    customerPretty: 'Customer Name Pretty',
    status: 'DELIVERED',
    positions: [
      { positionId: 'kleine-kapseln-40g', amount: 123 },
      { positionId: 'große-kapseln-120g', amount: 14 },
    ],
    history: [],
    trackingId: 'iaojiowjoifjoa',
    trackingLink: { de: 'https://post.at?id=iaojiowjoifjoa&lang=de', en: 'https://post.at?id=iaojiowjoifjoa&lang=en' },
    trackingProvider: 'POST',
  },
  {
    userRole: 'EVA',
    erpId: 'some-erpId-12121221',
    sender: 'SOME_SENDER',
    id: 'second-delivered-order',
    priority: 'LOW',
    createdBy: 'BERNHARD',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'BERNHARD',
    updatedAt: timestampMockHelpers.tenMinutesLater,
    customerId: 'customer-1',
    customerPretty: 'Customer Name Pretty',
    status: 'DELIVERED',
    positions: [{ positionId: 'palette-800-100', amount: 17 }],
    history: [],
    trackingId: 'f88a238rar98',
    trackingLink: { en: 'https://post.at?id=f88a238rar98&lang=en' },
    trackingProvider: 'POST',
  },
];
